<template>
    <div>
        <template v-if="isMultiple">
             <b-button variant="dark" @click="openModal" size="sm" v-if="this.value !== null"> <b-icon icon="eye" /> </b-button>
            <main-dialog size="sm" v-model="modalView" :hide-header=true :hide-footer=true >
                <b-row>
                    <b-col sm="12" v-for="cont in value" :key="cont" class="file" >
                        <a :href="cont" target="_blank">
                            <span :class="`fiv-cla fiv-icon-${getFileExtension(cont)}`"> </span>
                            {{ fileName(cont) }}
                        </a>
                    </b-col>
                </b-row>
            </main-dialog>
        </template>
        <template v-else>
             <a :href="value" target="_blank">
                <span :class="`fiv-cla fiv-icon-${getFileExtension(value)}`"> </span>
                {{ fileName(value) }}
            </a>
        </template>
       
    </div>
</template>

<script>
export default {
    props: {
        field: {
            type: Object
        },
        itemField: {
            type: Object
        },
        value: {
            type: String | Number | Object
        }
    },

    data: function() {
        return {
            image: null,
            modalView: false
        }
    },

    methods: {
        openModal(e) {
            e.stopImmediatePropagation();

            this.modalView = true;
        },

        getFileExtension(name) {
            let l = name.split(".")

            return l[l.length - 1]
        },

        fileName(name) {
            let cont = name.split("/")

            return cont[cont.length - 1]
        },
    },

    computed: {
        isMultiple() {
            return !(typeof this.value == 'string')
        }
    },

    mounted() {
        
    }
}
</script>